export const reformGroups = [
  {
    title: "内装・原状回復",
    icon: "ri-layout-masonry-line",
    items: ["クロス張替え", "床工事", "内装工事", "原状回復工事"],
  },
  {
    title: "屋根・外まわり",
    icon: "ri-home-gear-line",
    items: [
      "屋根塗装",
      "屋根修理",
      "屋根葺き替え",
      "屋根カバー工事",
      "外壁塗装",
      "雨樋工事",
      "防水工事",
    ],
  },
  {
    title: "その他住宅リフォーム",
    icon: "ri-tools-line",
    items: ["水まわり", "その他住宅リフォーム", "まずはご相談ください"],
  },
];

type ReformWork = {
  label: string;
  caption: string;
  img?: string;
  /** 元画像を加工せず切り出して表示するための指定（割合 0〜1 / ratio は横÷縦） */
  photo?: {
    src: string;
    x: number;
    y: number;
    w: number;
    h: number;
    ratio: number;
  };
};

export const reformWorks: ReformWork[] = [
  {
    label: "屋根工事",
    caption: "屋根塗装・修理・葺き替え・カバー工事",
    photo: {
      src: "https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/2f0617b39b1471a8e70f5a9e02054a3d.jpeg",
      x: 0.545,
      y: 0.348,
      w: 0.41,
      h: 0.5125,
      ratio: 1.667,
    },
  },
  {
    label: "外壁塗装",
    caption: "外壁塗装・雨樋・防水工事",
    photo: {
      src: "https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/cb94126e0be589bcf9487621ee54917b.jpeg",
      x: 0.54,
      y: 0.317,
      w: 0.415,
      h: 0.519,
      ratio: 1.667,
    },
  },
  {
    label: "内装・原状回復",
    caption: "クロス張替え・床・内装・原状回復",
    img: "https://readdy.ai/api/search-image?query=Interior%20renovation%20of%20a%20bright%20empty%20Japanese%20room%2C%20new%20light%20wallpaper%20and%20clean%20wooden%20flooring%20being%20installed%2C%20paint%20tools%20and%20materials%20neatly%20placed%2C%20soft%20natural%20window%20light%2C%20clean%20and%20orderly%20interior%20work%20scene%2C%20no%20people%2C%20high%20detail%2C%20calm%20and%20fresh%20atmosphere&width=800&height=600&seq=kobayashi-reform-interior-01&orientation=landscape",
  },
];